/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

const styles = {
  cardContent: css`
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border: 1px solid #ccc;
    padding: 10px;

    .card-logo-container {
      margin-right: 12px;
    }

    .card-info-container {
      font-size: 0.9em;

      p {
        color: #777;
        font-size: 0.8em;
        margin: 0;
      }
    }
  `,
};

export type Props = {
  photoSrc?: string;
  name: string;
  link: string;
  partnerName: string;
};

const IMAGE_PARAMS = {
  fit: 'crop',
};

const IMAGE_WIDTH = 36;
const IMAGE_HEIGHT = 36;

// CardContent renders a card with an image, name, and partner name.
const CardContent: React.FC<Props> = ({ photoSrc, partnerName, name, link }) => {
  return (
    <div className="rc-CardContent" css={styles.cardContent}>
      <div className="card-logo-container">
        {/* Use Imgix component to display the image with specified parameters, width, and height */}
        <Imgix
          className="card-logo"
          maxWidth={IMAGE_WIDTH}
          maxHeight={IMAGE_HEIGHT}
          imgParams={IMAGE_PARAMS}
          src={photoSrc || 'images/teach-s12n/empty_image_placeholder.png'}
          alt={Imgix.DECORATIVE}
        />
      </div>
      <div className="card-info-container">
        {/* Display the name as a link */}
        <a href={link}> {name} </a>
        {/* Display the partner name */}
        <p className="partner-name"> {partnerName} </p>
      </div>
    </div>
  );
};

export default CardContent;
